<template>
  <v-form ref="form" :disabled="loader.loading" @submit.prevent="submit">
    <t-tabs
      v-model="tab"
      :tabs="tabs"
      @submit="submit"
    >
      <template #window-footer>
        <div class="d-flex justify-end">
          <v-col md="3">
            <v-btn
              type="submit"
              color="primary"
              size="large"
              class="w-100"
              :loading="loader.loading"
              :disabled="loader.loading"
            >
              Salvar
            </v-btn>
          </v-col>
        </div>
      </template>
    </t-tabs>
  </v-form>
</template>

<script lang="ts" setup>
import { useLoader } from '@/stores/loader'
import { TabProp } from '@/types/vuetify/Tab'
import TabBasicInfo from './partials/tab-basic-info.vue'
import TTabs from '@/components/TTabs.vue'
import { ref } from 'vue'
import TabPermissions from './partials/tab-permissions.vue'
import { AdminUpdateRequest } from '@/services/AdminService'

const loader = useLoader()

const model = defineModel<AdminUpdateRequest>({ required: true })

const emit = defineEmits<{
  submit: [ AdminUpdateRequest ]
}>()

const { readonly = false, editing = false } = defineProps<{
  readonly: boolean
  editing: boolean
}>()

const tab = ref(0)

const tabs: TabProp[] = [
  {
    icon: 'fa-regular fa-pen-to-square',
    title: 'Informações Básicas',
    component: TabBasicInfo,
    props: { modelValue: model.value, readonly, editing },
  },
  {
    icon: 'fa-regular fa-gears',
    title: 'Cargos e Permissões',
    component: TabPermissions,
    eager: true,
    props: { modelValue: model.value, readonly, editing },
  },
]

function submit() {
  emit('submit', model.value)
}

</script>
